module.exports = __webpack_public_path__ + "img/txxx.2dc35c4d.png";